import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function FamoraLogo({ size = 64 }) {
  return (
    <img src="/famora-logo.svg" width={size} height={size}
      alt="Famora" style={{ borderRadius: size * 0.22, display: 'block' }} />
  );
}

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();

  // steg: 'info' → 'choice' → 'new' | 'join'
  const [step, setStep]       = useState('info');
  const [form, setForm]       = useState({ familyName:'', name:'', email:'', password:'' });
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);

  const set = key => e => setForm(f => ({...f, [key]: e.target.value}));

  const goToChoice = e => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim()) return;
    setStep('choice');
  };

  const handleRegister = async e => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await register(form.familyName, form.name, form.email, form.password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Registrering feilet');
    } finally { setLoading(false); }
  };

  const inp  = { padding:'12px 14px', borderRadius:12, border:'1px solid rgba(255,255,255,0.13)', background:'rgba(255,255,255,0.08)', fontFamily:'inherit', fontSize:14, color:'#fff', outline:'none', marginBottom:14, width:'100%', boxSizing:'border-box' };
  const lbl  = { fontSize:11, fontWeight:700, color:'rgba(255,255,255,0.45)', textTransform:'uppercase', letterSpacing:'.8px', marginBottom:3, display:'block' };
  const btn  = { padding:'14px', borderRadius:14, border:'none', background:'linear-gradient(135deg,#7C6FF7,#5B4FD4)', color:'#fff', fontFamily:'inherit', fontSize:15, fontWeight:700, cursor:'pointer', marginTop:8, boxShadow:'0 4px 20px rgba(124,111,247,0.4)', width:'100%', boxSizing:'border-box' };
  const back = { padding:'11px', borderRadius:12, border:'1px solid rgba(255,255,255,0.15)', background:'transparent', color:'rgba(255,255,255,0.5)', fontFamily:'inherit', fontSize:14, cursor:'pointer', marginTop:10, width:'100%', textAlign:'center', boxSizing:'border-box' };
  const err  = { background:'rgba(239,68,68,0.15)', color:'#FCA5A5', padding:'10px 14px', borderRadius:12, fontSize:13, marginBottom:18, border:'1px solid rgba(239,68,68,0.3)' };

  const stepLabels = { info:'1', choice:'2', new:'3', join:'3' };
  const stepTitles = {
    info:   'Kom i gang',
    choice: 'Velg alternativ',
    new:    'Opprett familie',
    join:   'Bli med i familie',
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(160deg, #1A0A4E 0%, #3D1B8E 35%, #1A1245 70%, #0D0B1E 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 20, position: 'relative', overflow: 'hidden',
      fontFamily: "'Plus Jakarta Sans', sans-serif",
    }}>
      {/* Glødende bakgrunnsblobs */}
      <div style={{ position:'absolute', top:-120, right:-120, width:450, height:450, borderRadius:'50%', background:'rgba(124,111,247,0.28)', filter:'blur(90px)', pointerEvents:'none' }}/>
      <div style={{ position:'absolute', bottom:-150, left:-100, width:400, height:400, borderRadius:'50%', background:'rgba(93,58,227,0.22)', filter:'blur(90px)', pointerEvents:'none' }}/>
      <div style={{ position:'absolute', top:'40%', left:'-8%', width:220, height:220, borderRadius:'50%', background:'rgba(147,88,232,0.18)', filter:'blur(60px)', pointerEvents:'none' }}/>

      {/* Kortcontainer */}
      <div style={{
        width: '100%', maxWidth: 420,
        background: 'rgba(255,255,255,0.06)',
        backdropFilter: 'blur(30px)', WebkitBackdropFilter: 'blur(30px)',
        borderRadius: 28,
        border: '1px solid rgba(255,255,255,0.13)',
        boxShadow: '0 28px 70px rgba(0,0,0,0.55), inset 0 1px 0 rgba(255,255,255,0.08)',
        overflow: 'hidden',
      }}>
        {/* Gradient-topp */}
        <div style={{
          background: 'linear-gradient(145deg, #7C6FF7 0%, #9358E8 50%, #5E4AE3 100%)',
          padding: '32px 32px 28px',
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden',
        }}>
          <div style={{ position:'absolute', top:-40, right:-40, width:150, height:150, borderRadius:'50%', background:'rgba(255,255,255,0.08)', pointerEvents:'none' }}/>
          <div style={{ position:'absolute', bottom:-50, left:-30, width:130, height:130, borderRadius:'50%', background:'rgba(255,255,255,0.05)', pointerEvents:'none' }}/>
          <div style={{ position:'relative', zIndex:1 }}>
            <div style={{ display:'flex', justifyContent:'center', marginBottom:12 }}>
              <FamoraLogo size={60} />
            </div>
            <h1 style={{ fontSize:28, fontWeight:800, color:'#fff', margin:'0 0 4px', letterSpacing:'-0.5px' }}>Famora</h1>
            <p style={{ fontSize:13, color:'rgba(255,255,255,0.7)', margin:'0 0 16px' }}>Opprett familiekonto — gratis!</p>

            {/* Steg-indikator */}
            <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:0 }}>
              {['1','2','3'].map((n, i) => {
                const cur = stepLabels[step];
                const active = parseInt(n) <= parseInt(cur);
                return (
                  <React.Fragment key={n}>
                    <div style={{ width:28, height:28, borderRadius:'50%', background: active?'rgba(255,255,255,0.9)':'rgba(255,255,255,0.2)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:12, fontWeight:800, color: active?'#7C6FF7':'rgba(255,255,255,0.5)', transition:'all .2s' }}>
                      {n}
                    </div>
                    {i < 2 && <div style={{ width:32, height:2, background: parseInt(n) < parseInt(cur)?'rgba(255,255,255,0.6)':'rgba(255,255,255,0.2)', transition:'all .2s' }}/>}
                  </React.Fragment>
                );
              })}
            </div>
            <div style={{ fontSize:12, color:'rgba(255,255,255,0.65)', marginTop:8, fontWeight:600 }}>{stepTitles[step]}</div>
          </div>
        </div>

        {/* Innhold */}
        <div style={{ padding: '28px 32px 32px' }}>

          {/* ── STEG 1: Navn og e-post ── */}
          {step === 'info' && (
            <>
              {error && <div style={err}>{error}</div>}
              <form onSubmit={goToChoice} style={{ display:'flex', flexDirection:'column' }}>
                <label style={lbl}>Ditt navn</label>
                <input style={inp} placeholder="Kari Hansen" value={form.name} onChange={set('name')} required autoFocus />
                <label style={lbl}>E-post</label>
                <input style={inp} type="email" placeholder="kari@example.com" value={form.email} onChange={set('email')} required />
                <button style={btn} type="submit">Fortsett →</button>
              </form>
              <p style={{ textAlign:'center', fontSize:13, color:'rgba(255,255,255,0.38)', marginTop:20, marginBottom:0 }}>
                Har du allerede konto? <Link to="/logg-inn" style={{ color:'#A78BFA', fontWeight:700, textDecoration:'none' }}>Logg inn</Link>
              </p>
            </>
          )}

          {/* ── STEG 2: Velg ny eller eksisterende familie ── */}
          {step === 'choice' && (
            <>
              <p style={{ fontSize:15, color:'rgba(255,255,255,0.7)', textAlign:'center', margin:'0 0 20px', fontWeight:500 }}>
                Hva vil du gjøre, <strong style={{ color:'#fff' }}>{form.name.split(' ')[0]}</strong>?
              </p>
              <div style={{ display:'flex', flexDirection:'column', gap:10, marginBottom:16 }}>
                <button onClick={() => setStep('new')} style={{ display:'flex', alignItems:'center', gap:16, padding:'18px 20px', borderRadius:16, border:'1px solid rgba(124,111,247,0.4)', background:'rgba(124,111,247,0.12)', cursor:'pointer', fontFamily:'inherit', textAlign:'left', transition:'.15s' }}>
                  <span style={{ fontSize:32, flexShrink:0 }}>🏠</span>
                  <div>
                    <div style={{ fontSize:15, fontWeight:700, color:'#fff', marginBottom:2 }}>Opprett ny familie</div>
                    <div style={{ fontSize:12, color:'rgba(255,255,255,0.45)' }}>Du blir administrator</div>
                  </div>
                  <span style={{ marginLeft:'auto', color:'rgba(255,255,255,0.4)', fontSize:20 }}>›</span>
                </button>
                <button onClick={() => setStep('join')} style={{ display:'flex', alignItems:'center', gap:16, padding:'18px 20px', borderRadius:16, border:'1px solid rgba(255,255,255,0.1)', background:'rgba(255,255,255,0.05)', cursor:'pointer', fontFamily:'inherit', textAlign:'left', transition:'.15s' }}>
                  <span style={{ fontSize:32, flexShrink:0 }}>👨‍👩‍👧</span>
                  <div>
                    <div style={{ fontSize:15, fontWeight:700, color:'#fff', marginBottom:2 }}>Bli med i eksisterende</div>
                    <div style={{ fontSize:12, color:'rgba(255,255,255,0.45)' }}>Du er invitert av noen</div>
                  </div>
                  <span style={{ marginLeft:'auto', color:'rgba(255,255,255,0.4)', fontSize:20 }}>›</span>
                </button>
              </div>

              <div style={{ display:'flex', alignItems:'center', gap:10, margin:'4px 0 14px', color:'rgba(255,255,255,0.18)', fontSize:11 }}>
                <div style={{ flex:1, height:1, background:'rgba(255,255,255,0.1)' }}/>
                <span style={{ fontWeight:600, letterSpacing:'.5px' }}>ELLER REGISTRER MED</span>
                <div style={{ flex:1, height:1, background:'rgba(255,255,255,0.1)' }}/>
              </div>
              <a href="/api/auth/facebook" style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:10, padding:'12px', borderRadius:13, background:'#1877F2', color:'#fff', fontFamily:'inherit', fontSize:14, fontWeight:700, textDecoration:'none', marginBottom:10 }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="white" style={{flexShrink:0}}>
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
                Registrer med Facebook
              </a>
              <button style={back} onClick={() => setStep('info')}>← Tilbake</button>
            </>
          )}

          {/* ── STEG 3a: Opprett ny familie ── */}
          {step === 'new' && (
            <>
              {error && <div style={err}>{error}</div>}
              <form onSubmit={handleRegister} style={{ display:'flex', flexDirection:'column' }}>
                <label style={lbl}>Familienavn</label>
                <input style={inp} placeholder="Familien Hansen" value={form.familyName} onChange={set('familyName')} required autoFocus />
                <label style={lbl}>Passord (min. 8 tegn)</label>
                <input style={inp} type="password" value={form.password} onChange={set('password')} required minLength={8} />
                <div style={{ background:'rgba(124,111,247,0.12)', border:'1px solid rgba(124,111,247,0.3)', borderRadius:12, padding:'12px 16px', margin:'4px 0 6px', display:'flex', flexDirection:'column', gap:6 }}>
                  <div style={{ display:'flex', justifyContent:'space-between', fontSize:13 }}>
                    <span style={{ color:'rgba(255,255,255,0.45)' }}>Navn</span>
                    <span style={{ color:'#fff', fontWeight:600 }}>{form.name}</span>
                  </div>
                  <div style={{ display:'flex', justifyContent:'space-between', fontSize:13 }}>
                    <span style={{ color:'rgba(255,255,255,0.45)' }}>E-post</span>
                    <span style={{ color:'#fff', fontWeight:600 }}>{form.email}</span>
                  </div>
                </div>
                <button style={{ ...btn, opacity: loading ? 0.7 : 1 }} type="submit" disabled={loading}>
                  {loading ? 'Oppretter…' : '🏠 Opprett familiekonto'}
                </button>
              </form>
              <button style={back} onClick={() => setStep('choice')}>← Tilbake</button>
            </>
          )}

          {/* ── STEG 3b: Bli med i eksisterende familie ── */}
          {step === 'join' && (
            <>
              <p style={{ fontSize:14, color:'rgba(255,255,255,0.6)', textAlign:'center', margin:'0 0 18px' }}>
                Bli med i en eksisterende familie
              </p>
              <div style={{ display:'flex', flexDirection:'column', gap:10, background:'rgba(255,255,255,0.05)', borderRadius:16, padding:'18px 16px', marginBottom:16 }}>
                {[
                  { n:'1', t:'Kontakt administratoren i familien du vil bli med i' },
                  { n:'2', t:'Be dem invitere deg via Innstillinger → Legg til voksen' },
                  { n:'3', t:'Du vil motta en e-post med innloggingsdetaljer' },
                  { n:'4', t:`Logg inn med e-posten: ${form.email}` },
                ].map(item => (
                  <div key={item.n} style={{ display:'flex', alignItems:'flex-start', gap:12, fontSize:14, color:'rgba(255,255,255,0.75)', lineHeight:1.5 }}>
                    <div style={{ width:24, height:24, borderRadius:'50%', background:'linear-gradient(135deg,#7C6FF7,#9358E8)', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:700, fontSize:12, color:'#fff', flexShrink:0, marginTop:1 }}>
                      {item.n}
                    </div>
                    <span>{item.t}</span>
                  </div>
                ))}
              </div>
              <div style={{ display:'flex', gap:10 }}>
                <button style={{ ...back, marginTop:0, flex:1 }} onClick={() => setStep('choice')}>← Tilbake</button>
                <Link to="/logg-inn" style={{ ...btn, textDecoration:'none', textAlign:'center', flex:1, display:'flex', alignItems:'center', justifyContent:'center', marginTop:0, boxSizing:'border-box' }}>
                  Gå til innlogging
                </Link>
              </div>
            </>
          )}

          <div style={{ display:'flex', justifyContent:'center', alignItems:'center', gap:8, marginTop:20 }}>
            <a href="https://famora.no/personvern" style={{ fontSize:11, color:'rgba(255,255,255,0.22)', textDecoration:'none' }} rel="noreferrer" target="_blank">Personvern</a>
            <span style={{ color:'rgba(255,255,255,0.15)', fontSize:11 }}>·</span>
            <a href="https://famora.no/vilkar" style={{ fontSize:11, color:'rgba(255,255,255,0.22)', textDecoration:'none' }} rel="noreferrer" target="_blank">Vilkår</a>
          </div>
        </div>
      </div>
    </div>
  );
}
